export default {
    'Firewall Allgemein': [
        {
            question: 'Welche Netzwerkschnittstellen sind üblicherweise in einer Firewall verbaut und weswegen?',
            score: 100,
            answered: false,
        },
        {
            question: 'Welche Elemente muss eine Firewall-Policy mindestens beinhalten?',
            score: 200,
            answered: false,
        },
        {
            question: 'Wofür steht die Abkürzung "NAT"? Was tut es und wofür wird es eingesetzt?',
            score: 300,
            answered: false,
        },
        {
            question: 'Nenne mindestens drei Netzwerkdienste und ihre dazugehörigen Ports. Spezifiziere auch, ob TCP oder UDP verwendet wird.',
            score: 400,
            answered: false,
        }
    ],
    'Firewall Funktionen': [
        {
            question: 'Was ist der Unterschied zwischen einem Web-Filter und einem Proxy-Server?',
            score: 100,
            answered: false,
        },
        {
            question: 'Wofür steht die Abkürzung "DPI"?',
            score: 200,
            answered: false,
        },
        {
            question: 'Was versteht man unter Quality of Service?',
            score: 300,
            answered: false,
        },
        {
            question: 'Wofür stehen die folgenden Abkürzungen und was ist der Unterschied zwischen ihnen: IDS, IPS?',
            score: 400,
            answered: false,
        },
    ],
    'Kryptographie Allgemein': [
        {
            question: 'Was ist Steganographie?',
            score: 100,
            answered: false,
        },
        {
            question: 'Nenne eine Hash-Funktion und einen Anwendungsfall für Hashes',
            score: 200,
            answered: false,
        },
        {
            question: 'Nenne eine Falls, für welchen man ein gültiges Zertifikat benötigt.',
            score: 300,
            answered: false,
        },
        {
            question: 'Wofür steht die Abkürzung "PKI"? Was beinhaltet diese?',
            score: 400,
            answered: false,
        },
    ],
    'Kryptographische Verfahren': [
        {
            question: 'Nenne zwei Verschlüsselungsverfahren',
            score: 100,
            answered: false,
        },
        {
            question: 'Nenne zwei gängige Verschlüsselungsalgorithmen.',
            score: 200,
            answered: false,
        },
        {
            question: 'Nenne ein Beispiel für die Verwendung eines Schlüsselpaares aus privatem und öffentlichem Schlüssel.',
            score: 300,
            answered: false,
        },
        {
            question: 'Was ist CBC? Was ist EBC? Was ist der Unterschied?',
            score: 400,
            answered: false,
        },
    ],
    VPN: [
        {
            question: 'Nenne zwei VPN-Lösungen',
            score: 100,
            answered: false,
        },
        {
            question: 'Was ist Split Tunneling?',
            score: 200,
            answered: false,
        },
        {
            question: 'Was ist der Unterschied zwischen einem Remote Access- und einem Site-ot-Site-VPN?',
            score: 300,
            answered: false,
        },
        {
            question: 'Was ist der Unterschied zwischen einem SSL-VPN und IPsec?',
            score: 400,
            answered: false,
        },
    ],
    WAS: [
        {
            question: 'Was ist eine UTM?',
            score: 100,
            answered: false,
        },
        {
            question: 'Was ist DNSSEC?',
            score: 200,
            answered: false,
        },
        {
            question: 'Was ist ein Reverse-Proxy?',
            score: 300,
            answered: false,
        },
        {
            question: 'Nenne zwei MFA-Methoden.',
            score: 400,
            answered: false,
        },
    ],
    'Security Analysis': [
        {
            question: 'Was versteht man unter Grundschutz?',
            score: 100,
            answered: false,
        },
        {
            question: 'Nenne einen Dienst mit dessen Hilfe man detailierte Analysen von Dateien erhalten kann.',
            score: 200,
            answered: false,
        },
        {
            question: 'Nenne zwei "Standardwerke" im IT-Security-Bereich.',
            score: 300,
            answered: false,
        },
        {
            question: 'Welche fünf Schritte umfasst das NIST Cybersecurity Framework?',
            score: 400,
            answered: false,
        },
    ],
    Hacking: [
        {
            question: 'Nenne zwei Bedeutungen des Wortes "Hack"',
            score: 100,
            answered: false,
        },
        {
            question: 'Nenne zwei "Hacks"/"Hacking-Methoden".',
            score: 200,
            answered: false,
        },
        {
            question: 'Nenne drei Tools, die Kali Linux uns bietet, um zu "hacken".',
            score: 300,
            answered: false,
        },
        {
            question: 'Beschreibe, wie ein MITM-Angriff durchgeführt werden kann.',
            score: 400,
            answered: false,
        },
    ],
};
